import BaseComponent from 'scripts/BaseComponent.js';
import { AccessibilityHelper } from 'scripts/accessibility/accessibilityHelper';

export default class Accordion extends BaseComponent {
  constructor(component) {
    super(component);

    this.refs = {
      parent: '.js-accordionParent',
      toggle: '.js-accordionItemToggle',
      content: '.js-accordionItemContent',
    };

    this.dom = {
      $component: component,
      $toggle: this.$getAll(this.refs.toggle),
      $parents: this.$getAll(this.refs.parent),
    };

    this.state = {
      open: false,
      openClass: 'is-open',
      activeEl: null,
      accessibilityHelper: new AccessibilityHelper(),
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$toggle, this.toggleClick);
  }

  toggleClick(event) {
    const { state, refs } = this;

    const newAccordion = event.target.closest(refs.parent);

    if (state.open && (newAccordion === state.activeEl)) {
      this.close();
    } else {
      this.close();
      this.open(newAccordion);
    }
  }

  open(accordion) {
    const { state, refs } = this;

    const content = accordion.querySelector(refs.content);
    accordion.classList.add(state.openClass);
    content.style.maxHeight = `${content.scrollHeight}px`;
    content.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    state.accessibilityHelper.updateElementAccessibility(content, true);
    state.activeEl = accordion;
    document.addEventListener('click', this.clickOutHandler.bind(this));
    state.open = true;
  }

  close() {
    const { dom, state, refs } = this;

    dom.$parents.forEach(($parent) => {
      const content = $parent.querySelector(refs.content);
      $parent.classList.remove(state.openClass);
      content.style.maxHeight = 0;
      content.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      state.accessibilityHelper.updateElementAccessibility(content, false);
    });
    document.removeEventListener('click', this.clickOutHandler.bind(this));
    state.activeEl = null;
    state.open = false;
  }

  clickOutHandler(e) {
    const { dom } = this;

    dom.$parents.forEach(($parent) => {
      if (!$parent.contains(e.target)) {
        this.close();
      }
    });
  }
}
